import React, { MouseEvent } from 'react';
import { GoogleIcon } from '../icons';
import SocialButton from './SocialButton';

interface Props {
  onClick: (event: MouseEvent<HTMLButtonElement>) => void;
}

const GoogleButton: React.FC<Props> = ({ onClick, children }) => {
  return (
    <SocialButton icon={<GoogleIcon />} onClick={onClick}>
      {children}
    </SocialButton>
  );
};

export default GoogleButton;
